import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { useAuth } from "../../../hooks/useAuth";
import { BackToMyPageButton } from "../../molecules/BackToMyPageButton";
import { EmailEditForm } from "../../organisms/form/EmailEditForm";
import { useEmailEdit } from "./hook";

export const EmailEdit: React.FC = () => {
  const { handleEmailError } = useAuth();
  const { handleEmailEdit } = useEmailEdit();

  return (
    <Container>
      <TitleWrapper>メールアドレスの変更</TitleWrapper>

      <EmailEditForm
        handleEmailError={handleEmailError}
        handleSubmit={handleEmailEdit}
      />

      <ButtonWrapper>
        <BackToMyPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px 43px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  padding: 43px 0 38px;
  display: flex;
  font-weight: 600;
  line-height: 1;
  font-family: "Hiragino Sans";
  justify-content: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  button {
    font-family: "Hiragino Sans";
    font-weight: 500;
    line-height: 1em;
    height: auto;
  }
`;
